import classNames from 'classnames';
import Icon from 'components/Icon';
import { Button } from 'components/Button';
import './NavToggle.css';

const NavToggle = ({ menuOpen, ...rest }) => {
  const iconClass = classNames('nav-toggle_icon', {
    'nav-toggle_icon--open': menuOpen,
  });

  return (
    <Button
      iconOnly
      className="nav-toggle"
      aria-label="Menu"
      aria-expanded={menuOpen}
      {...rest}
    >
      <div className="nav-toggle_inner">
        <Icon
          className={classNames(iconClass, 'nav-toggle_icon--menu')}
          open={menuOpen}
          icon="menu"
        />
        <Icon
          className={classNames(iconClass, 'nav-toggle_icon--close')}
          open={menuOpen}
          icon="close"
        />
      </div>
    </Button>
  );
};

export default NavToggle;
